export default {
	containers_auth_components_login: {
		f_required: 'Field is required',
		password_placeholder: 'Password*',
		username_placeholder: 'Username*',
		submit: 'Submit',
	},
}